/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'prohibit': {
    width: 9,
    height: 9,
    viewBox: '0 0 9 9',
    data: '<path pid="0" _fill="#CF1010" d="M7.74 0L8.8 1.06 1.537 8.327.476 7.265z"/>'
  }
})
